module.exports = __webpack_public_path__ + "media/images/mobile/home/search_b-2f6bf27e1a8c5308f2b798fb79890620.png";